import { render, staticRenderFns } from "./TeacherExcelUpload.vue?vue&type=template&id=2d6beb99&"
import script from "./TeacherExcelUpload.vue?vue&type=script&lang=ts&"
export * from "./TeacherExcelUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports